/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum RoleName {
  Administrator = 'Administrator',
  BillingAdministrator = 'BillingAdministrator',
  CommitteeMember = 'CommitteeMember',
  Editor = 'Editor',
  Viewer = 'Viewer'
}
